export const GREETING_STEP = 'greeting';
export const GENERAL_STEP = 'general';
export const MAP_STEP = 'map';
export const LANDING_STEP = 'landing';
export const PAD_VIEW_STEP = 'view';
export const HAZARDS_STEP = 'hazards';
export const APPROACH_STEP = 'approach';
export const FACILITIES_STEP = 'facilities';